import { createSlice } from "@reduxjs/toolkit";
import {
  clampHeatmapLabelDigits,
  DEFAULT_HEATMAP_LABEL_DIGITS_BY_LAYER,
} from "../components/threeDComponent/heatmapLabelLayers";

const initialState = {
  value: 0,
  filter: [],
  ceilingList: null,
  floorsList: null,
  facadeList: null,
  internalWalls: null,
  scenarioList: null,
  energyValueList: null,
  windDirectionList: null,
  pvPanels: null,
  roofTop: null,
  stairs: null,
  sensorPlacement: null,
  sensorPlacementZoneConfig: null,
  shadingProgression: null,
  shadingProgressionStep: null,
  shadingProgressionDate: null,
  shadingControlScenarios: [],
  soundEmission: null,
  windRisk: null,
  stairsList: null,
  doors: null,
  windRiskDirectionsList: [],
  pvPanelsData: null,
  buildingsInfo: [],
  cameraDistanceToTarget: [30, 20, 70],
  cameraTarget: [0, 0, 0],
  defaultCameraTarget: [0, 0, 0],
  cameraPosition: [30, 20, 70],
  defaultCameraPosition: [30, 20, 70],
  heatmapLabelsEnabled: false,
  heatmapLabelsAdaptive: true,
  heatmapLabelsSizePercent: 100,
  heatmapLabelDigitsByLayer: { ...DEFAULT_HEATMAP_LABEL_DIGITS_BY_LAYER },
};

const sceneGlobalSlice = createSlice({
  name: "sceneVar",
  initialState,
  reducers: {
    updateCamera: (state, action) => {
      const [x, y, z] = action.payload;
      const r = Math.random() / 100;
      const newTarget = [x + r, y, z];
      state.cameraTarget = newTarget;
      state.cameraPosition = newTarget.map(
        (coord, index) => coord + state.cameraDistanceToTarget[index],
      );
    },
    setV: (state, action) => {
      state.value = action.payload;
    },
    updateFilter: (state, action) => {
      state.filter[0] = action.payload[0];
    },
    resetChosenFilter: (state, action) => {
      state.filter = [];
    },
    setGlobalSceneVariable: (state, action) => {
      state.ceilingList = action.payload[0];
      state.floorsList = action.payload[1];
      state.facadeList = action.payload[2];
      state.internalWalls = action.payload[3];
      state.scenarioList = action.payload[4];
      state.energyValueList = action.payload[5];
      state.windDirectionList = action.payload[6];
      state.pvPanels = action.payload[7];
      state.roofTop = action.payload[8];
      state.stairs = action.payload[9];
      state.sensorPlacement = action.payload[10];
      state.shadingProgression = action.payload[11];
      state.windRisk = action.payload[12];
      state.stairsList = action.payload[13];
      state.doors = action.payload[14];
      state.windRiskDirectionsList = action.payload[15];
      state.pvPanelsData = action.payload[16];
      state.buildingsInfo = action.payload[17];
      state.sensorPlacementZoneConfig = action.payload[18];
      state.shadingProgressionStep = action.payload[19];
      state.shadingProgressionDate = action.payload[20];
      state.shadingControlScenarios = action.payload[21] ?? [];
      state.soundEmission = action.payload[22];
    },
    setHeatmapLabelsEnabled: (state, action) => {
      state.heatmapLabelsEnabled = action.payload;
    },
    setHeatmapLabelsAdaptive: (state, action) => {
      state.heatmapLabelsAdaptive = action.payload;
    },
    setHeatmapLabelsSizePercent: (state, action) => {
      state.heatmapLabelsSizePercent = action.payload;
    },
    setHeatmapLabelDigits: (state, action) => {
      const { layer, digits } = action.payload || {};
      if (!layer || state.heatmapLabelDigitsByLayer?.[layer] == null) return;
      state.heatmapLabelDigitsByLayer[layer] = clampHeatmapLabelDigits(digits);
    },
  },
});
export const {
  setV,
  updateFilter,
  resetChosenFilter,
  setGlobalSceneVariable,
  resetCameraPosition,
  updateCamera,
  setHeatmapLabelsEnabled,
  setHeatmapLabelsAdaptive,
  setHeatmapLabelsSizePercent,
  setHeatmapLabelDigits,
} = sceneGlobalSlice.actions;

export default sceneGlobalSlice.reducer;
